import React, { useContext } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import Photo from './Photo';
import { Grid } from '../common/Grid';
import ComponentTitle from '../common/ComponentTitle';
import LayoutContext, { MODERN_LAYOUT_COLLAPSE_WIDTH } from '../../contexts/Layout';

const PhotoGrid = ({ contentItems = {}, nodeTypeAlias = 'PhotoGrid', title, width, hardWidth }) => {
    const { layout } = useContext(LayoutContext);

    const items = Object.values(contentItems).map((photo, index) => (
        <View>
            <Photo
                {...photo}
                key={`photo-grid-item-${index}`}
                index={index}
                style={{
                    marginBottom: index % 2 !== 0 ? 0 : layout.styleGuide.spacer10,
                    marginRight: index % 2 === 0 ? layout.styleGuide.spacer10 : 0
                }}
                width={width <= MODERN_LAYOUT_COLLAPSE_WIDTH ? width : width * 0.5}
                dataSet={{
                    spacerBottom: index % 2 !== 0 ? 0 : `StyleGuide.Spacer10(${layout.styleGuide.spacer10})`,
                    spacerRight: index % 2 === 0 ? `StyleGuide.Spacer10(${layout.styleGuide.spacer10})` : 0
                }}
            />
        </View>
    ));

    return (
        <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            {!!title && <ComponentTitle title={title} />}
            <Grid items={items} width={hardWidth} />
        </View>
    );
};

PhotoGrid.propTypes = {
    title: PropTypes.string,
    contentItems: PropTypes.object
};

export default PhotoGrid;
